import { Logger, LoggerService } from "@Shared/logger";
import { EntitlementOptions } from "./_models";


export class EntitlementModuleClass {
    private Logger: Logger = LoggerService.createLogger("EntitlementModule");


    private options: EntitlementOptions;

    get Options(): EntitlementOptions {
        return this.options;
    }

    constructor() {
        this.Logger.trace("**** CTOR ****");
    }

    public async init(opts: EntitlementOptions): Promise<void> {
        this.Logger.trace("Options Initializing");
        try {


            this.options = opts;


            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);


        }

    }


}

export const EntitlementModule = new EntitlementModuleClass();